<template lang="pug">
  .absolute.inset-0.flex.flex-col.justify-center.items-center
    .max-w-screen-lg.text-center(class="w-10/12")
      .font-display.text-lightCyan.italic.tracking-widest(class="text-lg md:text-3xl") MISSON : 1
      h2.misson-title(ref="title")
        img.mx-auto(class="hidden ls:block" alt="オリジナルマグロボを完成させよ！" src="images/common/misson-1.png" srcset="images/common/misson-1@2x.png 2x")
        img.mx-auto(class="ls:hidden" alt="オリジナルマグロボを完成させよ！" src="images/common/misson-1-sp.png" srcset="images/common/misson-1-sp@2x.png 2x, images/common/misson-1-sp@3x.png 3x")
      .max-w-md.mx-auto
        p(class="text-xs md:text-base") キャンパス内に隠れたマグロボのパーツをさがして
          span.inline-block 自分だけのオリジナルマグロボをつくってくれ! 
          span.inline-block キミにレアアイテムを見つけられるか？
        .mt-8
          router-link(class="w-48 router-link" to="/map") 探索をはじめる
</template>

<script>
export default {
  name: "Home",
  mounted() {
    this.$nextTick(() => {
      this.$refs.title.classList.add("animation");
    });
  }
};
</script>
